<div class="mbm-banner" [class.mbm-banner-offline]="variant() === 'offline'" [class.mbm-banner-info]="variant() === 'info'" role="status" aria-live="polite">
  <span class="mbm-banner-message">{{ messageKey() | translate }}</span>
  @if (actionTextKey()) {
    <button type="button" class="mbm-banner-action" (click)="actionClick.emit()">{{ actionTextKey()! | translate }}</button>
  }
</div>
